import { GGCoinClient } from "@developerz.ai/ggcoin-sdk";

/** The API base: `VITE_API_BASE_URL`, falling back to the dev-proxy path `/api`. */
export function apiBaseUrl(): string {
  return (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "/api";
}

/**
 * Build one client per browser session.
 * Tests pass a custom fetch by constructing `GGCoinClient` directly.
 */
export function buildClient(jwt: string | null = null): GGCoinClient {
  return new GGCoinClient({ baseUrl: apiBaseUrl(), jwt: jwt ?? undefined });
}
